"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["className", "style", "children", "cntitle", "entitle", "mbshowtitle", "responsive"];
var AnchorPanel = function AnchorPanel(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    cntitle = props.cntitle,
    entitle = props.entitle,
    _props$mbshowtitle = props.mbshowtitle,
    mbshowtitle = _props$mbshowtitle === void 0 ? true : _props$mbshowtitle,
    responsive = props.responsive,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("anchor-panel-body");
  var classes = (0, _classnames.default)(prefixCls, className, {
    responsive: responsive
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style
  }, extraProps), (!!cntitle || !!entitle) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("".concat(prefixCls, "__title"), {
      "show-title-mb": mbshowtitle
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__title--main")
  }, !!entitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__title--en")
  }, entitle), !!cntitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__title--cn")
  }, cntitle))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__con")
  }, children));
};
var _default = AnchorPanel;
exports.default = _default;